class Verification extends HTMLElement {
  constructor() {
    super();
    this.agreeButton = null;
    this.disagreeButton = null;
    this.wrapper = null;
    this.body = document.body;
    this.content = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.agreeButton = this.querySelector(".age-verification__button--agree");
    this.disagreeButton = this.querySelector(
      ".age-verification__button--disagree"
    );
    this.wrapper = this;

    if (!this.agreeButton || !this.disagreeButton || !this.wrapper) return;

    this.agreeButton.addEventListener("click", () => this.verified());
    this.disagreeButton.addEventListener("click", () => this.honestAnswer());

    if (this.getCookie("age_verified") !== "true") {
      this.wrapper.classList.remove("hidden");
      this.wrapper.classList.add("flex");
    }

    this.handleImageLoadAnimations();
  }

  verified() {
    this.setCookie("age_verified", "true", 365);
    this.hideVerification();
    Alpine.store("stockNotificationPopup").initAutoPopupOpening();
  }

  honestAnswer() {
    this.wrapper.classList.add("younger-than-21");
  }

  hideVerification() {
    this.wrapper.classList.add("verified");
    setTimeout(() => {
      this.wrapper.classList.add("hidden");
    }, 2500);
  }

  setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = `${name}=${value}; path=/ ${expires}`;
  }

  getCookie(name) {
    const match = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]+)")
    );
    return match ? match[2] : null;
  }

  handleImageLoadAnimations() {
    const imagesWrappersList = this.querySelectorAll(".images-wrapper__image");
    if (!imagesWrappersList) return;

    imagesWrappersList.forEach((imageWrapper) => {
      const image = imageWrapper.querySelector("img");
      if (!image) return;
      if (image.complete) {
        image.classList.add("!opacity-100");
      } else {
        image.addEventListener("load", () => {
          image.classList.add("duration-1000");
          image.classList.add("!opacity-100");
        });
      }
    });
  }
}

customElements.define("age-verification", Verification);
